import { cn } from "@/lib/utils";

interface GridPatternProps {
  className?: string;
  /** Cell size in pixels. */
  size?: number;
}

/** SVG dot/grid pattern. Pure CSS, no JS runtime cost. */
export function GridPattern({ className, size = 36 }: GridPatternProps) {
  const id = `grid-pattern-${size}`;
  return (
    <svg
      aria-hidden
      className={cn(
        "pointer-events-none absolute inset-0 h-full w-full",
        "text-foreground/[0.06]",
        className,
      )}
    >
      <defs>
        <pattern
          id={id}
          width={size}
          height={size}
          patternUnits="userSpaceOnUse"
        >
          <path
            d={`M ${size} 0 L 0 0 0 ${size}`}
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
          />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill={`url(#${id})`} />
    </svg>
  );
}
